import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Modal from "react-modal";
import { toast, ToastContainer } from "react-toastify";
import Pagination from "../../components/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

Modal.setAppElement("#root");

export default function Mixing(props) {
  const [reports, setReports] = useState(props.reports);
  const [divisions, setDivisions] = useState(props.divisions);
  const [forms, setForms] = useState(props.forms);
  const [periods, setPeriods] = useState(props.periods);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedReportName, setSelectedReportName] = useState("");
  const [selectedPeriodStart, setSelectedPeriodStart] = useState("");
  const [selectedPeriodEnd, setSelectedPeriodEnd] = useState("");
  const [selectedForm, setSelectedForm] = useState(forms[0].id);
  const [selectedDivisions, setSelectedDivisions] = useState([]);
  const [expandedDivisions, setExpandedDivisions] = useState({}); // Хранит состояние раскрытых подразделений
  const userRole = props.user_role;
  const userId = props.user_id;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);
  // Функция для открытия модального окна
  const openModal = () => setIsModalOpen(true);

  // Функция для закрытия модального окна
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPeriodStart("");
    setSelectedPeriodEnd("");
  };
  

  // Функция для отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Проверка: все обязательные поля заполнены
    if (!selectedReportName) {
      toast.error("Название отчета обязательно.");
      return;
    }

    if (!selectedPeriodStart || !selectedPeriodEnd) {
      toast.error("Необходимо выбрать период.");
      return;
    }

 

    if (!selectedForm) {
      toast.error("Необходимо выбрать форму.");
      return;
    }

    // Проверка: хотя бы один пользователь должен быть выбран
    let users_ids;
    if (userRole === 1) {
      // Если роль пользователя 1, отправляем только его ID
      users_ids = [userId];
    } else {
      if (selectedDivisions.length === 0) {
        toast.error(
          "Необходимо выбрать хотя бы одного пользователя из подразделений."
        );
        return;
      }
      // Маппируем selectedDivisions, чтобы отправить только user_id
      users_ids = selectedDivisions.map(
        (divisionUser) => divisionUser.split("-")[1]
      );
    }

    // Подготовка данных для отправки
    const data = {
      report_name: selectedReportName,
      period_start: selectedPeriodStart,
      period_end: selectedPeriodEnd,
      form_id: selectedForm,
      users_ids, // Передаем только user_ids
    };

setIsSubmitting(true); // блокируем кнопку, пока идёт сведение

    try {
      const response = await fetch("/reports", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const responseData = await response.json(); // Парсим JSON-ответ
        window.location.href = responseData.link; // Переходим по полученному линку        // Можно добавить логику для обновления списка отчетов или перезагрузки данных
      } else {
        if (response.status === 400) {
          toast.error("Дата окончания периода не может быть раньше даты начала периода");
        } else {
          toast.error("Ошибка при создании отчета. Попробуйте снова.");
        }
        setIsSubmitting(false); // ошибка — снова разрешаем нажать
      }
    } catch (error) {
      toast.error("Ошибка при соединении с сервером.");
      setIsSubmitting(false); // ошибка соединения — снова разрешаем нажать
    }
  };

  // Функция для переключения состояния раскрытия подразделения
  const toggleDivision = (divisionId) => {
    setExpandedDivisions((prev) => ({
      ...prev,
      [divisionId]: !prev[divisionId],
    }));
  };

  // Функция для обработки выбора подразделения или пользователя
  const handleDivisionSelection = (divisionId, userId = null) => {
    setSelectedDivisions((prev) => {
      if (userId === null) {
        // Если выбран только division, добавляем всех пользователей из этого подразделения
        const divisionUsers =
          divisions
            .find((d) => d.id === divisionId)
            ?.users.map((u) => `${divisionId}-${u.id}`) || [];

        if (prev.some((id) => id.startsWith(`${divisionId}-`))) {
          // Если подразделение уже выбрано, удаляем всех пользователей из этого подразделения
          return prev.filter((id) => !id.startsWith(`${divisionId}-`));
        } else {
          // Добавляем всех пользователей из подразделения
          return [...prev, ...divisionUsers];
        }
      } else {
        // Для конкретного пользователя (userId)
        const userKey = `${divisionId}-${userId}`;
        if (prev.includes(userKey)) {
          return prev.filter((id) => id !== userKey);
        } else {
          return [...prev, userKey];
        }
      }
    });
  };

  // Функция для обработки выбора всех пользователей из всех подразделений
  const handleSelectAll = () => {
    const allUsers = divisions.flatMap((division) =>
      division.users.map((user) => `${division.id}-${user.id}`)
    );
    setSelectedDivisions(allUsers);
  };

  // Функция для отмены выбора всех пользователей из всех подразделений
  const handleDeselectAll = () => {
    setSelectedDivisions([]);
  };

  // Функция для получения доступных периодов
  const getAvailablePeriods = () =>
    periods.map((period) => ({
      id: period.id, // Используем ID
      displayValue: period.period,
    }));

  const openDeleteModal = (reportId) => {
    setReportToDelete(reportId);
    setIsDeleteModalOpen(true);
  };

  // Функция закрытия модального окна
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setReportToDelete(null);
  };

  // Функция подтверждения удаления
  const confirmDeleteReport = async () => {
    try {
      const response = await fetch(`/reports/${reportToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        toast.success("Отчет успешно удален!");
        setReports(reports.filter((report) => report.id !== reportToDelete));
        closeDeleteModal();
      } else {
        toast.error("Ошибка при удалении отчета. Попробуйте снова.");
      }
    } catch (error) {
      toast.error("Ошибка при соединении с сервером.");
    }
  };
  return (
    <div className="min-h-full bg-gray-50">
      <ToastContainer />
      <div className="pb-32">
        <Navbar props={props} />

        {/* Заголовок */}
        <header className="py-12">
          <div className="mx-auto container max-w-screen-2xl px-4">
            <h1 className="text-3xl font-semibold tracking-tight text-black">
              Отчеты
            </h1>
            <button
              onClick={openModal}
              className="mt-4 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
              Создать новый отчет
            </button>
          </div>
        </header>
      </div>

      {/* Основной контент */}
      <main className="-mt-32">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
          <div className="overflow-hidden rounded-lg bg-white shadow-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gradient-to-r from-blue-700 to-blue-800 text-white">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                    Наименование
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                    Форма
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                    Дата создания
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                    Действия
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {reports.map((report) => (
                  <tr key={report.id}>
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      <a
                        href={`/reports/${report.id}/edit`}
                        className="text-indigo-600 hover:text-indigo-900"
                      >
                        {report.name}
                      </a>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500">
                      {report.short_name}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500">
                      {new Date(report.date_created).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium flex space-x-4">
                      <a
                        href={`/reports/${report.id}/edit`}
                        className="text-indigo-600 hover:text-indigo-900"
                        title="Редактировать"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                      </a>
                      <button
                        onClick={() => openDeleteModal(report.id)}
                        className="text-red-600 hover:text-red-900"
                        title="Удалить"
                      >
                        <FontAwesomeIcon icon={faTrashAlt} size="sm" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={props.current_page}
            totalPages={props.total_pages}
            basePath="/reports/mixing"
          />
        </div>
      </main>

      {/* Модальное окно */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="bg-white p-6 rounded shadow-md max-w-lg mx-auto mt-20"
        overlayClassName="fixed inset-0 bg-gray-500 bg-opacity-75"
      >
        <h2 className="text-xl font-semibold mb-4">Создать новый отчет</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Название отчета
            </label>
            <input
              type="text"
              value={selectedReportName}
              onChange={(e) => setSelectedReportName(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Период
            </label>
            <div className="flex space-x-2">
              <select
                value={selectedPeriodStart}
                onChange={(e) => setSelectedPeriodStart(e.target.value)}
                className="mt-1 block w-1/2 border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              >
                <option value="" disabled>
                  Начало периода
                </option>
                {getAvailablePeriods().map((period) => (
                  <option key={period.id} value={period.id}>
                    {period.displayValue}
                  </option>
                ))}
              </select>
              <select
                value={selectedPeriodEnd}
                onChange={(e) => setSelectedPeriodEnd(e.target.value)}
                className="mt-1 block w-1/2 border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              >
                <option value="" disabled>
                  Конец периода
                </option>
                {getAvailablePeriods().map((period) => (
                  <option key={period.id} value={period.id}>
                    {period.displayValue}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Форма
            </label>
            <select
              value={selectedForm}
              onChange={(e) => setSelectedForm(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
            >
              {forms.map((form) => (
                <option key={form.id} value={form.id}>
                  {form.short_name}
                </option>
              ))}
            </select>
          </div>

          {/* Блок подразделений не отображается для userRole === 1 */}
          {userRole !== 1 && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Подразделения
              </label>
              <div className="max-h-40 overflow-y-auto border rounded-md p-2">
                {/* Кнопки для выбора всех или отмены выбора всех */}
                <div className="mb-2 flex justify-between">
                  <button
                    type="button"
                    onClick={handleSelectAll}
                    className="text-blue-600"
                  >
                    Выбрать всех
                  </button>
                  <button
                    type="button"
                    onClick={handleDeselectAll}
                    className="text-red-600"
                  >
                    Отменить всех
                  </button>
                </div>
                {divisions.map((division) => (
                  <div key={division.id} className="mb-2">
                    {/* Раздел */}
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={selectedDivisions.some((id) =>
                          id.startsWith(`${division.id}-`)
                        )}
                        onChange={() => handleDivisionSelection(division.id)}
                        className="mr-2"
                      />
                      <button
                        type="button"
                        className="text-left font-medium"
                        onClick={() => toggleDivision(division.id)}
                      >
                        {division.name.trim()}
                      </button>
                    </div>

                    {/* Пользователи подразделения */}
                    {expandedDivisions[division.id] &&
                      division.users.map((user) => (
                        <div key={user.id} className="ml-6 flex items-center">
                          <input
                            type="checkbox"
                            checked={selectedDivisions.includes(
                              `${division.id}-${user.id}`
                            )}
                            onChange={() =>
                              handleDivisionSelection(division.id, user.id)
                            }
                            className="mr-2"
                          />
                          {user.realname}
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Сообщение во время сведения */}
          {isSubmitting && (
            <p className="mb-3 text-sm text-gray-600">
              Идёт сведение отчёта, это может занять до минуты. Пожалуйста,
              подождите и не закрывайте страницу.
            </p>
          )}

          {/* Кнопки */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              disabled={isSubmitting}
              className={`mr-2 rounded px-4 py-2 ${
                isSubmitting ? "bg-gray-200 cursor-not-allowed" : "bg-gray-300"
              }`}
            >
              Отмена
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`rounded px-4 py-2 text-white ${
                isSubmitting
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {isSubmitting ? "Сводится…" : "Сохранить"}
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        className="bg-white p-6 rounded shadow-md max-w-md mx-auto mt-20"
        overlayClassName="fixed inset-0 bg-gray-500 bg-opacity-75"
      >
        <h2 className="text-xl font-semibold mb-4">Подтверждение удаления</h2>
        <p className="text-gray-700 mb-6">
          Вы уверены, что хотите удалить этот отчет? Это действие необратимо.
        </p>
        <div className="flex justify-end">
          <button
            onClick={closeDeleteModal}
            className="mr-2 rounded bg-gray-300 px-4 py-2"
          >
            Отмена
          </button>
          <button
            onClick={confirmDeleteReport}
            className="rounded bg-red-600 px-4 py-2 text-white hover:bg-red-700"
          >
            Удалить
          </button>
        </div>
      </Modal>
    </div>
  );
}
